export const defaultSharedTableStates = {
  page: 1,
  perPage: 5,
  search: '',
};
